import { InfiniteListBase } from "ra-core";
import type { Identifier } from "ra-core";
import type { ReactNode } from "react";

import { ActivityLogContext } from "./ActivityLogContext";
import { ActivityLogIterator } from "./ActivityLogIterator";

type ActivityLogProps = {
  companyId?: Identifier;
  pageSize?: number;
  context?: "company" | "contact" | "deal" | "all";
  /** Rendered above the feed, inside its list context (e.g. a note form that refetches it). */
  children?: ReactNode;
};

export function ActivityLog({
  companyId,
  pageSize = 20,
  context = "all",
  children,
}: ActivityLogProps) {
  return (
    <ActivityLogContext.Provider value={context}>
      <InfiniteListBase
        resource="activity_log"
        filter={companyId ? { company_id: companyId } : {}}
        sort={{ field: "date", order: "DESC" }}
        perPage={pageSize}
        disableSyncWithLocation
      >
        {children}
        <ActivityLogIterator />
      </InfiniteListBase>
    </ActivityLogContext.Provider>
  );
}
